import ListReferralsTable from "../ReferTab/MyReferralTable";
import TransactionHistory from "./transactionhistory";
import Withdraw from "./withdraw";
import WithdrawTable from "./WithdrawTable";

function Transaction(){
  return(
    <>
    <div className="row">
      <div className="col-lg-12">
         <TransactionHistory />
         <div className="mt-5">
           <WithdrawTable />
         </div>
         <div className="mt-5">
           <ListReferralsTable />
         </div>
      </div>
    </div>
    </>
  )
}
export default Transaction;
